module.exports = __webpack_public_path__ + "static/media/close-modal.ef216e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user-new/close-modal.png
// module id = 771
// module chunks = 0